// Adds shared modules to the window
// interested packages will pick them from there
// using webpack externals

window["@bolteu/lattice"] = require("@bolteu/lattice");
window["react"] = require("react");
window["react-dom"] = require("react-dom");
window["react-intl"] = require("react-intl");
window["react-router"] = require("react-router");
window["react-router-dom"] = require("react-router-dom");
